import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../../../common/utils';
import { HubLoanerPhoneItemFacade } from './hub-loaner-phone-item.facade';

@Injectable({
  providedIn: 'root',
})
export class HubLoanerPhoneItemGuard {
  constructor(private hubLoanerPhoneItemFacade: HubLoanerPhoneItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { hubId, phoneId },
    } = route;
    return loadStoreState(this.hubLoanerPhoneItemFacade, { hubId, phoneId });
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.hubLoanerPhoneItemFacade);
  }
}
